export const SkipPlusLearnMorePlaceholderLocalStorageKey = "skipPlusLearnMorePlaceholder";
